<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <!-- Notificaciones -->
        <div v-for="(notification, index) in notifications" :key="index" 
             class="alert position-fixed top-0 end-0 m-3" 
             :class="notification.class" 
             role="alert" 
             style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" 
                  type="button" 
                  class="btn-close" 
                  @click="closeNotification(index)"
                  aria-label="Close"></button>
        </div>

        <!-- Contenido principal -->
        <div class="row">
          <!-- Columna izquierda - Tabla de contactos -->
          <div class="col-5">
            <div class="card mb-4">
              <div class="card-header pb-0 d-flex align-items-center">
                <h6>Contactos</h6>
                <button @click="nuevoContacto" class="btn btn-primary btn-sm ms-auto">
                  <i class="fas fa-plus me-2"></i>Nuevo Contacto
                </button>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <!-- Buscador -->
                <div class="px-3 py-3 d-flex gap-2 align-items-center">
                  <input type="text" 
                         class="form-control" 
                         placeholder="Buscar contacto..." 
                         v-model="searchContacto" 
                         style="max-width: 100%; min-height: 38px;">
                </div>
                
                <!-- Tabla de contactos -->
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">DNI</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Empresa</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="contacto in contactosPaginados" 
                          :key="contacto.id" 
                          @click="seleccionarContacto(contacto)"
                          :class="{ 'table-active': contactoSeleccionado?.id === contacto.id }">
                        <td class="align-middle text-start">
                          <span class="text-secondary text-xs font-weight-bold">{{ contacto.nombre }} {{ contacto.apellidos }}</span>
                        </td>
                        <td class="align-middle text-start">
                          <span class="text-secondary text-xs font-weight-bold">{{ contacto.dni }}</span>
                        </td>
                        <td class="align-middle text-start">
                          <span class="text-secondary text-xs font-weight-bold">{{ contacto.empresa || '-' }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Paginación -->
                <nav aria-label="Page navigation" v-if="totalContactos > pageLength">
                  <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" 
                              @click="changePage(currentPage - 1)" 
                              :disabled="currentPage === 1">
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                    </li>
                    <li class="page-item" 
                        v-for="page in paginationRange" 
                        :key="'page_' + page">
                      <button class="page-link" 
                              @click="changePage(page)"
                              :style="{ 
                                backgroundColor: page === currentPage ? 'black' : '', 
                                color: page === currentPage ? 'white' : '' 
                              }">
                        {{ page }}
                      </button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button class="page-link" 
                              @click="changePage(currentPage + 1)" 
                              :disabled="currentPage === totalPages">
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <!-- Columna derecha - Detalles del contacto seleccionado -->
          <div class="col-7">
            <div class="card mb-4" v-if="contactoSeleccionado">
              <div class="card-header pb-0 d-flex align-items-center">
                <h6>DATOS CONTACTO</h6>
                <div class="ms-auto">
                  <button class="btn btn-danger btn-sm me-2" 
                          @click="confirmarEliminarContacto"
                          :disabled="guardando">
                    <i class="fas fa-trash me-1"></i>
                    Eliminar
                  </button>
                  <button class="btn btn-primary btn-sm" 
                          @click="guardarContactoSeleccionado"
                          :disabled="guardando">
                    <span v-if="guardando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    Guardar
                  </button>
                </div>
              </div>
              <div class="card-body">
                <!-- Formulario de edición -->
                <div class="row mb-4">
                  <div class="col-md-6">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Nombre</h6>
                    <input class="form-control" 
                           type="text" 
                           v-model="contactoSeleccionado.nombre"
                           placeholder="Ingrese el nombre"
                           :class="{ 'is-invalid': errores.nombre }">
                    <div v-if="errores.nombre" class="invalid-feedback">
                      {{ errores.nombre }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Apellidos</h6>
                    <input class="form-control" 
                           type="text" 
                           v-model="contactoSeleccionado.apellidos"
                           placeholder="Ingrese los apellidos"
                           :class="{ 'is-invalid': errores.apellidos }">
                    <div v-if="errores.apellidos" class="invalid-feedback">
                      {{ errores.apellidos }}
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">DNI</h6>
                    <input class="form-control" 
                           type="text" 
                           v-model="contactoSeleccionado.dni"
                           placeholder="12345678A"
                           :class="{ 'is-invalid': errores.dni }">
                    <div v-if="errores.dni" class="invalid-feedback">
                      {{ errores.dni }}
                    </div>
                  </div>
                <div class="col-md-6">
                  <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Empresa</h6>
                  <select class="form-control"
                          v-model="contactoSeleccionado.empresa"
                          :class="{ 'is-invalid': errores.empresa }">
                    <option value="">Selecciona una empresa</option>
                    <option v-for="empresa in empresasDisponibles" :key="'emp-sel-' + empresa.id" :value="empresa.descripcion">
                      {{ empresa.descripcion }}
                    </option>
                    <option v-if="contactoSeleccionado.empresa && !empresasDisponibles.some(e => e.descripcion === contactoSeleccionado.empresa)"
                            :value="contactoSeleccionado.empresa">
                      {{ contactoSeleccionado.empresa }}
                    </option>
                  </select>
                  <div v-if="errores.empresa" class="invalid-feedback">
                    {{ errores.empresa }}
                  </div>
                </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Cargo</h6>
                    <input class="form-control" 
                           type="text" 
                           v-model="contactoSeleccionado.cargo"
                           placeholder="Puesto de trabajo"
                           :class="{ 'is-invalid': errores.cargo }">
                    <div v-if="errores.cargo" class="invalid-feedback">
                      {{ errores.cargo }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Móvil</h6>
                    <input class="form-control" 
                           type="tel" 
                           v-model="contactoSeleccionado.movil"
                           placeholder="+34 600 000 000"
                           :class="{ 'is-invalid': errores.movil }">
                    <div v-if="errores.movil" class="invalid-feedback">
                      {{ errores.movil }}
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Email</h6>
                    <input class="form-control" 
                           type="email" 
                           v-model="contactoSeleccionado.email"
                           placeholder="correo@ejemplo.com"
                           :class="{ 'is-invalid': errores.email }">
                    <div v-if="errores.email" class="invalid-feedback">
                      {{ errores.email }}
                    </div>
                  </div>
                </div>

                <!-- Información del sistema -->
                <div v-if="contactoSeleccionado.created_at" class="row">
                  <div class="col-12">
                    <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 mb-3">
                      Información del Sistema
                    </h6>
                    <div class="row">
                      <div class="col-md-6">
                        <small class="text-muted">
                          <strong>Creado:</strong> {{ formatearFecha(contactoSeleccionado.created_at) }}
                        </small>
                      </div>
                      <div class="col-md-6">
                        <small class="text-muted">
                          <strong>Última actualización:</strong> {{ formatearFecha(contactoSeleccionado.updated_at) }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mensaje cuando no hay contacto seleccionado -->
            <div class="card mb-4" v-else>
              <div class="card-body text-center py-5">
                <i class="fas fa-address-book fa-3x text-muted mb-3"></i>
                <h6 class="text-muted">Selecciona un contacto para ver sus detalles</h6>
                <p class="text-muted small">Haz clic en cualquier contacto de la tabla para ver su información completa</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de formulario -->
      <div v-if="mostrarModalContactoForm" 
           class="modal fade show" 
           tabindex="-1" 
           style="display: block; background: rgba(0,0,0,0.3);"
           @click.self="cerrarModalFormulario">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ esEditando ? 'Editar Contacto' : 'Nuevo Contacto' }}</h5>
              <button type="button" 
                      class="btn-close" 
                      @click="cerrarModalFormulario"
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Formulario -->
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-control-label">Nombre <span class="text-danger">*</span></label>
                  <input class="form-control" 
                         type="text" 
                         v-model="contactoForm.nombre"
                         placeholder="Ingrese el nombre"
                         :class="{ 'is-invalid': errores.nombre }">
                  <div v-if="errores.nombre" class="invalid-feedback">
                    {{ errores.nombre }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Apellidos <span class="text-danger">*</span></label>
                  <input class="form-control" 
                         type="text" 
                         v-model="contactoForm.apellidos"
                         placeholder="Ingrese los apellidos"
                         :class="{ 'is-invalid': errores.apellidos }">
                  <div v-if="errores.apellidos" class="invalid-feedback">
                    {{ errores.apellidos }}
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-control-label">DNI <span class="text-danger">*</span></label>
                  <input class="form-control" 
                         type="text" 
                         v-model="contactoForm.dni"
                         placeholder="12345678A"
                         :class="{ 'is-invalid': errores.dni }">
                  <div v-if="errores.dni" class="invalid-feedback">
                    {{ errores.dni }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Empresa</label>
                  <select class="form-control"
                          v-model="contactoForm.empresa"
                          :class="{ 'is-invalid': errores.empresa }">
                    <option value="">Selecciona una empresa</option>
                    <option v-for="empresa in empresasDisponibles" :key="'emp-form-' + empresa.id" :value="empresa.descripcion">
                      {{ empresa.descripcion }}
                    </option>
                    <option v-if="contactoForm.empresa && !empresasDisponibles.some(e => e.descripcion === contactoForm.empresa)"
                            :value="contactoForm.empresa">
                      {{ contactoForm.empresa }}
                    </option>
                  </select>
                  <div v-if="errores.empresa" class="invalid-feedback">
                    {{ errores.empresa }}
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-control-label">Cargo</label>
                  <input class="form-control" 
                         type="text" 
                         v-model="contactoForm.cargo"
                         placeholder="Puesto de trabajo"
                         :class="{ 'is-invalid': errores.cargo }">
                  <div v-if="errores.cargo" class="invalid-feedback">
                    {{ errores.cargo }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Móvil</label>
                  <input class="form-control" 
                         type="tel" 
                         v-model="contactoForm.movil"
                         placeholder="+34 600 000 000"
                         :class="{ 'is-invalid': errores.movil }">
                  <div v-if="errores.movil" class="invalid-feedback">
                    {{ errores.movil }}
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-12">
                  <label class="form-control-label">Email</label>
                  <input class="form-control" 
                         type="email" 
                         v-model="contactoForm.email"
                         placeholder="correo@ejemplo.com"
                         :class="{ 'is-invalid': errores.email }">
                  <div v-if="errores.email" class="invalid-feedback">
                    {{ errores.email }}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      @click="cerrarModalFormulario">
                Cancelar
              </button>
              <button type="button" 
                      class="btn btn-primary" 
                      @click="guardarContacto"
                      :disabled="guardando">
                <span v-if="guardando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ esEditando ? 'Actualizar' : 'Crear' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de confirmación -->
      <div v-if="mostrarModalConfirmacion" 
           class="modal fade show" 
           tabindex="-1" 
           style="display: block; background: rgba(0,0,0,0.3);"
           @click.self="cerrarModalConfirmacion">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirmar Eliminación</h5>
              <button type="button" 
                      class="btn-close" 
                      @click="cerrarModalConfirmacion"
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>{{ mensajeConfirmacion }}</p>
              <p class="text-muted small">Esta acción no se puede deshacer.</p>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      @click="cerrarModalConfirmacion"
                      :disabled="eliminando">
                Cancelar
              </button>
              <button type="button" 
                      class="btn btn-danger" 
                      @click="eliminarContacto"
                      :disabled="eliminando">
                <span v-if="eliminando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import HeaderMenu from '@/components/HeaderMenu.vue';
import axiosInstance from '@/axios.js';

// Estado de la aplicación
const contactos = ref([]);
const cargando = ref(false);
const guardando = ref(false);
const eliminando = ref(false);
const esEditando = ref(false);
const contactoAEliminar = ref(null);
const contactoSeleccionado = ref(null);

// Estado del formulario
const contactoForm = reactive({
  id: null,
  nombre: '',
  apellidos: '',
  dni: '',
  empresa: '',
  cargo: '',
  email: '',
  movil: ''
});

// Estado de errores
const errores = reactive({
  nombre: '',
  apellidos: '',
  dni: '',
  empresa: '',
  cargo: '',
  email: '',
  movil: ''
});

// Estado de búsqueda y paginación
const searchContacto = ref('');
const pageLength = ref(10);
const currentPage = ref(1);

// Referencias a modales
const mostrarModalContactoForm = ref(false);
const mostrarModalConfirmacion = ref(false);

// Computed properties
const contactosFiltrados = computed(() => {
  const contactosArray = Array.isArray(contactos.value) ? contactos.value : [];
  
  if (!searchContacto.value) return contactosArray;
  
  const search = searchContacto.value.toLowerCase();
  return contactosArray.filter(contacto => 
    contacto.nombre.toLowerCase().includes(search) ||
    contacto.apellidos.toLowerCase().includes(search) ||
    contacto.dni.toLowerCase().includes(search) ||
    (contacto.empresa && contacto.empresa.toLowerCase().includes(search))
  );
});

const empresasDisponibles = ref([]);

const totalContactos = computed(() => contactosFiltrados.value.length);
const totalPages = computed(() => Math.ceil(totalContactos.value / pageLength.value));

const paginationRange = computed(() => {
  const range = [];
  const delta = 2;
  const start = Math.max(1, currentPage.value - delta);
  const end = Math.min(totalPages.value, currentPage.value + delta);
  for (let i = start; i <= end; i++) range.push(i);
  return range;
});

const contactosPaginados = computed(() => {
  const start = (currentPage.value - 1) * pageLength.value;
  const end = start + pageLength.value;
  return contactosFiltrados.value.slice(start, end);
});

const mensajeConfirmacion = computed(() => {
  return `¿Está seguro de que desea eliminar el contacto "${contactoAEliminar.value?.nombre} ${contactoAEliminar.value?.apellidos}"?`;
});

// Notificaciones
const notifications = ref([]);

const showNotification = (message, type) => {
  const notification = {
    message,
    class: type,
  };
  notifications.value.push(notification);

  setTimeout(() => {
    closeNotification(notifications.value.indexOf(notification));
  }, 3000);
};

const closeNotification = (index) => {
  notifications.value.splice(index, 1);
};

// Funciones de paginación
const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

// Funciones de carga de datos
const cargarContactos = async () => {
  cargando.value = true;
  try {
    const response = await axiosInstance.get('/api/contactos');
    contactos.value = response.data.data || [];
  } catch (error) {
    console.error('Error al cargar contactos:', error);
    showNotification('Error al cargar los contactos', 'alert-danger');
  } finally {
    cargando.value = false;
  }
};

const cargarEmpresas = async () => {
  try {
    const resp = await axiosInstance.get('/api/listas/48/valores');
    const valores = resp.data.data.lista.valores || [];
    const lista = Array.isArray(valores) ? valores : [];

    empresasDisponibles.value = lista
      .map(v => ({
        id: v.id || v.valor || v.descripcion,
        descripcion: v.descripcion || v.valor || v.nombre || ''
      }))
      .filter(v => v.descripcion)
      .sort((a, b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' }));
  } catch (error) {
    console.error('Error al cargar empresas (lista 48):', error);
    showNotification('No se pudieron cargar las empresas', 'alert-danger');
  }
};

// Funciones del formulario
const nuevoContacto = () => {
  esEditando.value = false;
  resetearFormulario();
  abrirModalFormulario();
};

const resetearFormulario = () => {
  contactoForm.id = null;
  contactoForm.nombre = '';
  contactoForm.apellidos = '';
  contactoForm.dni = '';
  contactoForm.empresa = '';
  contactoForm.cargo = '';
  contactoForm.email = '';
  contactoForm.movil = '';
  limpiarErrores();
};

const limpiarErrores = () => {
  Object.keys(errores).forEach(key => {
    errores[key] = '';
  });
};

const validarFormulario = () => {
  limpiarErrores();
  let esValido = true;

  // Validar campos requeridos
  if (!contactoForm.nombre.trim()) {
    errores.nombre = 'El nombre es obligatorio';
    esValido = false;
  }

  if (!contactoForm.apellidos.trim()) {
    errores.apellidos = 'Los apellidos son obligatorios';
    esValido = false;
  }

  if (!contactoForm.dni.trim()) {
    errores.dni = 'El DNI es obligatorio';
    esValido = false;
  }

  // Validar email si se proporciona
  if (contactoForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactoForm.email)) {
    errores.email = 'Formato de email inválido';
    esValido = false;
  }

  return esValido;
};

const guardarContacto = async () => {
  if (!validarFormulario()) return;

  guardando.value = true;
  try {
    const datos = {
      nombre: contactoForm.nombre.trim(),
      apellidos: contactoForm.apellidos.trim(),
      dni: contactoForm.dni.trim(),
      empresa: contactoForm.empresa?.trim() || '',
      cargo: contactoForm.cargo?.trim() || '',
      email: contactoForm.email?.trim() || '',
      movil: contactoForm.movil?.trim() || ''
    };

    if (esEditando.value) {
      await axiosInstance.put(`/api/contactos/${contactoForm.id}`, datos);
      showNotification('Contacto actualizado correctamente', 'alert-success');
    } else {
      await axiosInstance.post('/api/contactos', datos);
      showNotification('Contacto creado correctamente', 'alert-success');
    }

    cerrarModalFormulario();
    cargarContactos();
  } catch (error) {
    console.error('Error al guardar contacto:', error);
    if (error.response?.data?.errors) {
      const erroresBackend = error.response.data.errors;
      Object.keys(erroresBackend).forEach(key => {
        if (errores[key] !== undefined) {
          errores[key] = erroresBackend[key][0];
        }
      });
    } else {
      showNotification('Error al guardar el contacto', 'alert-danger');
    }
  } finally {
    guardando.value = false;
  }
};

const guardarContactoSeleccionado = async () => {
  if (!contactoSeleccionado.value) return;
  
  if (!validarContactoSeleccionado()) return;

  guardando.value = true;
  try {
    const datos = {
      nombre: contactoSeleccionado.value.nombre.trim(),
      apellidos: contactoSeleccionado.value.apellidos.trim(),
      dni: contactoSeleccionado.value.dni.trim(),
      empresa: contactoSeleccionado.value.empresa?.trim() || '',
      cargo: contactoSeleccionado.value.cargo?.trim() || '',
      email: contactoSeleccionado.value.email?.trim() || '',
      movil: contactoSeleccionado.value.movil?.trim() || ''
    };

    await axiosInstance.put(`/api/contactos/${contactoSeleccionado.value.id}`, datos);
    
    // Actualizar también en la lista principal
    const contactoIndex = contactos.value.findIndex(c => c.id === contactoSeleccionado.value.id);
    if (contactoIndex > -1) {
      Object.assign(contactos.value[contactoIndex], datos);
    }
    
    showNotification('Contacto actualizado correctamente', 'alert-success');
  } catch (error) {
    console.error('Error al guardar contacto:', error);
    if (error.response?.data?.errors) {
      const erroresBackend = error.response.data.errors;
      Object.keys(erroresBackend).forEach(key => {
        if (errores[key] !== undefined) {
          errores[key] = erroresBackend[key][0];
        }
      });
    } else {
      showNotification('Error al guardar el contacto', 'alert-danger');
    }
  } finally {
    guardando.value = false;
  }
};

const validarContactoSeleccionado = () => {
  limpiarErrores();
  let esValido = true;

  // Validar campos requeridos
  if (!contactoSeleccionado.value.nombre.trim()) {
    errores.nombre = 'El nombre es obligatorio';
    esValido = false;
  }

  if (!contactoSeleccionado.value.apellidos.trim()) {
    errores.apellidos = 'Los apellidos son obligatorios';
    esValido = false;
  }

  if (!contactoSeleccionado.value.dni.trim()) {
    errores.dni = 'El DNI es obligatorio';
    esValido = false;
  }

  // Validar email si se proporciona
  if (contactoSeleccionado.value.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactoSeleccionado.value.email)) {
    errores.email = 'Formato de email inválido';
    esValido = false;
  }

  return esValido;
};

const eliminarContacto = async () => {
  if (!contactoAEliminar.value) return;

  eliminando.value = true;
  try {
    await axiosInstance.delete(`/api/contactos/${contactoAEliminar.value.id}`);
    showNotification('Contacto eliminado correctamente', 'alert-success');
    cerrarModalConfirmacion();
    cargarContactos();
    
    // Si el contacto eliminado era el seleccionado, limpiar selección
    if (contactoSeleccionado.value?.id === contactoAEliminar.value.id) {
      contactoSeleccionado.value = null;
    }
  } catch (error) {
    console.error('Error al eliminar contacto:', error);
    showNotification('Error al eliminar el contacto', 'alert-danger');
  } finally {
    eliminando.value = false;
  }
};

// Funciones de modales
const abrirModalFormulario = () => {
  mostrarModalContactoForm.value = true;
};

const cerrarModalFormulario = () => {
  mostrarModalContactoForm.value = false;
};

const confirmarEliminarContacto = () => {
  if (!contactoSeleccionado.value) return;
  contactoAEliminar.value = contactoSeleccionado.value;
  mostrarModalConfirmacion.value = true;
};

const cerrarModalConfirmacion = () => {
  mostrarModalConfirmacion.value = false;
  contactoAEliminar.value = null;
};

// Funciones auxiliares
const formatearFecha = (fechaStr) => {
  if (!fechaStr) return '';
  const fecha = new Date(fechaStr);
  return fecha.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const seleccionarContacto = (contacto) => {
  contactoSeleccionado.value = { ...contacto };
};

// Watchers
watch(searchContacto, () => {
  currentPage.value = 1;
});

// Lifecycle
onMounted(() => {
  cargarContactos();
  cargarEmpresas();
});
</script>

<style scoped>
/* Estilos para la paginación redonda */
.pagination .page-item .page-link {
  border-radius: 50% !important;
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  min-height: 38px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 4px !important;
}

/* Estilos para las notificaciones */
.alert {
  z-index: 9999;
  max-width: 400px;
}

/* Estilos para la tabla */
.table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.table tbody tr.table-active {
  background-color: rgba(94, 114, 228, 0.1) !important;
  border-left: 3px solid #5e72e4;
}

/* Estilos para los botones de acción */
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

/* Estilos para el modal */
.modal-lg {
  max-width: 800px;
}

/* Estilos para el formulario */
.form-control:focus {
  border-color: #5e72e4;
  box-shadow: 0 0 0 0.2rem rgba(94, 114, 228, 0.25);
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>